import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	 theme: {
	    themes: {
	      light: {
	        primary: '#00dc82',
	        secondary: '#00DC82',
	        accent: '#f9780d',
	        error: '#ED7779',
	      },
	    },
	  },
});
